import { Button, kuiperClassNames } from '@opallabs/kuiper'
import { formattedDateObject } from '../../helpers/dateHelpers'

const DATE_FORMAT_SHORT = 'MMM D, YYYY'
const DATE_FORMAT_LONG = 'MMM D, YYYY h:mm A'

export const renderContentLiveDateDialogue = (dueDate) => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <div className={kuiperClassNames('popover-text')}>
      {"This phase hasn't been given a specific due date."}
    </div>
    <div className={kuiperClassNames('popover-date-title', 'warn')}>
      Content Scheduled Date
    </div>
    <div className={kuiperClassNames('popover-date', 'n10')}>
      {formattedDateObject(dueDate, DATE_FORMAT_SHORT)}
    </div>
  </div>
)

export const renderDueDateDialogue = (dueDate, contentLiveDate) => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <div className={kuiperClassNames('popover-date-title')}>Due Date</div>
    <div className={kuiperClassNames('popover-date')}>
      {formattedDateObject(dueDate, DATE_FORMAT_SHORT)}
    </div>
    <div className={kuiperClassNames('popover-date-title')}>
      Content Scheduled Date
    </div>
    <div className={kuiperClassNames('popover-date', 'n10')}>
      {formattedDateObject(contentLiveDate, DATE_FORMAT_SHORT)}
    </div>
  </div>
)

export const renderUndoDialogue = (user, completedAt, toggleTaskCompletion) => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <Button
      color="blue"
      label="Undo"
      type="invisible"
      onClick={toggleTaskCompletion}
    />
    <div className={kuiperClassNames('popover-hr')} />
    <div className={kuiperClassNames('popover-text')}>
      {`This task was completed by ${user.fullName}`}
    </div>
    <div className={kuiperClassNames('popover-date')}>
      {formattedDateObject(completedAt, DATE_FORMAT_LONG)}
    </div>
  </div>
)

export const renderUndoOwnDialogue = (completedAt, toggleTaskCompletion) => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <Button
      color="blue"
      label="Undo"
      type="invisible"
      onClick={toggleTaskCompletion}
    />
    <div className={kuiperClassNames('popover-hr')} />
    <div className={kuiperClassNames('popover-text')}>
      You completed this task
    </div>
    <div className={kuiperClassNames('popover-date')}>
      {formattedDateObject(completedAt, DATE_FORMAT_LONG)}
    </div>
  </div>
)

export const renderPhaseCompleteDialogue = () => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <div className={kuiperClassNames('popover-text')}>
      This task is in a completed phase. Only tasks in the current phase can be
      undone
    </div>
  </div>
)

export const renderFuturePhaseDialogue = () => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <div className={kuiperClassNames('popover-text')}>
      This task is in a future phase. Only tasks from the current phase can be
      completed
    </div>
  </div>
)

export const renderNoAccessDialogue = (toUser) => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <div className={kuiperClassNames('popover-text')}>
      {`${toUser.fullName} doesn't have access to this content.`}
    </div>
  </div>
)

export const renderDeleteConfirmationDialogue = (onDestroyPhaseItem) => (
  <div className={kuiperClassNames('phase-popover delete-popover', 'n10')}>
    <div className={kuiperClassNames('popover-text')}>
      Deleting this task will complete the phase. Do you want to delete it?
    </div>
    <div className={kuiperClassNames('popover-hr')} />
    <Button
      color="blue"
      label="Delete task and end phase"
      type="invisible"
      onClick={onDestroyPhaseItem}
    />
  </div>
)

export const renderConfirmationDialogue = (onConfirmCheck) => (
  <div className={kuiperClassNames('phase-popover', 'n10')}>
    <Button
      color="blue"
      label="Complete task"
      type="invisible"
      onClick={onConfirmCheck}
    />
    <div className={kuiperClassNames('popover-hr')} />
    <div className={kuiperClassNames('popover-text')}>
      This is the last remaining task. Completing it will start the next phase.
    </div>
  </div>
)

export const renderCompleteOnBehalfDialogue = (
  isLastTask,
  onConfirmCheck,
  onConfirmBehalfCheck
) => {
  if (isLastTask) {
    return (
      <div className={kuiperClassNames('phase-popover', 'n10')}>
        <Button
          color="blue"
          label="Complete task"
          type="invisible"
          onClick={onConfirmCheck}
        />
        <div className={kuiperClassNames('popover-hr')} />
        <div className={kuiperClassNames('popover-text')}>
          This task is assigned to someone else and is the last remaining task.
          Completing it will assign it to you and start the next phase.
        </div>
      </div>
    )
  }

  return (
    <div className={kuiperClassNames('phase-popover', 'n10')}>
      <Button
        color="blue"
        label="Complete task"
        type="invisible"
        onClick={onConfirmBehalfCheck}
      />
      <div className={kuiperClassNames('popover-hr')} />
      <div className={kuiperClassNames('popover-text')}>
        This task is assigned to someone else.
      </div>
    </div>
  )
}

export const renderDeleteCompletedConfirmationDialogue = (
  onDestroyPhaseItem
) => (
  <div className={kuiperClassNames('phase-popover delete-popover', 'n10')}>
    <div className={kuiperClassNames('popover-text')}>
      This task has already been marked as completed. Do you want to delete it?
    </div>
    <div className={kuiperClassNames('popover-hr')} />
    <Button
      color="blue"
      label="Delete task"
      type="invisible"
      onClick={onDestroyPhaseItem}
    />
  </div>
)
